"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  CampaignsApiTag: true,
  campaignsEntityAdapter: true,
  campaignListEntityAdapter: true,
  useGetCampaignsQuery: true,
  useGetCampaignByIdQuery: true,
  useGetCampaignListQuery: true,
  useSetIsCampaignFavouriteMutation: true
};
exports.useSetIsCampaignFavouriteMutation = exports.useGetCampaignListQuery = exports.useGetCampaignByIdQuery = exports.useGetCampaignsQuery = exports.campaignListEntityAdapter = exports.campaignsEntityAdapter = exports.CampaignsApiTag = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = require("@alycecom/utils");

var _toolkit = require("@reduxjs/toolkit");

var _EmptyAppApi = require("../EmptyAppApi");

var _prospectingBatches = require("./prospectingBatches/prospectingBatches");

Object.keys(_prospectingBatches).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _prospectingBatches[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _prospectingBatches[key];
    }
  });
});

var _activate = require("./activate/activate");

Object.keys(_activate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _activate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _activate[key];
    }
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CampaignsApiTag;
exports.CampaignsApiTag = CampaignsApiTag;

(function (CampaignsApiTag) {
  CampaignsApiTag["Campaign"] = "CampaignsApiTag_Campaign";
})(CampaignsApiTag || (exports.CampaignsApiTag = CampaignsApiTag = {}));

var campaignsEntityAdapter = (0, _toolkit.createEntityAdapter)();
exports.campaignsEntityAdapter = campaignsEntityAdapter;
var campaignListEntityAdapter = (0, _toolkit.createEntityAdapter)({
  selectId: function selectId(campaign) {
    return campaign.campaignId;
  }
});
exports.campaignListEntityAdapter = campaignListEntityAdapter;

var campaigns = _EmptyAppApi.emptyAppApi.enhanceEndpoints({
  addTagTypes: [CampaignsApiTag.Campaign]
}).injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getCampaigns: build.query({
        query: function query(params) {
          return "/api/v1/campaigns?".concat((0, _utils.deepQueryStringWithPaths)(params));
        }
      }),
      getCampaignById: build.query({
        query: function query(id) {
          return "/api/v1/campaigns?ids[]=".concat(id);
        },
        transformResponse: function transformResponse(response) {
          return response.data[0];
        },
        providesTags: function providesTags(result) {
          return result ? [{
            type: CampaignsApiTag.Campaign,
            id: result.id
          }] : [];
        }
      }),
      getCampaignList: build.query({
        query: function query() {
          return "/api/v1/campaign-list";
        },
        transformResponse: function transformResponse(response) {
          return campaignListEntityAdapter.addMany(campaignListEntityAdapter.getInitialState(), response.data);
        }
      }),
      setIsCampaignFavourite: build.mutation({
        query: function query(_ref) {
          var campaignId = _ref.campaignId,
              body = _ref.body;
          return {
            url: "/api/v1/campaigns/".concat(campaignId, "/favourite"),
            method: 'PUT',
            body: body
          };
        },
        transformResponse: function transformResponse(_response, _meta, arg) {
          return arg;
        },
        onQueryStarted: function () {
          var _onQueryStarted = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref2, _ref3) {
            var campaignId, body, dispatch, queryFulfilled, getCampaignByIdPatch;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    campaignId = _ref2.campaignId, body = _ref2.body;
                    dispatch = _ref3.dispatch, queryFulfilled = _ref3.queryFulfilled;
                    getCampaignByIdPatch = dispatch(campaigns.util.updateQueryData('getCampaignById', campaignId, function (draft) {
                      return _objectSpread(_objectSpread({}, draft), body);
                    }));
                    queryFulfilled["catch"](getCampaignByIdPatch.undo);

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onQueryStarted(_x, _x2) {
            return _onQueryStarted.apply(this, arguments);
          }

          return onQueryStarted;
        }()
      })
    };
  }
});

var useGetCampaignsQuery = campaigns.useGetCampaignsQuery,
    useGetCampaignByIdQuery = campaigns.useGetCampaignByIdQuery,
    useGetCampaignListQuery = campaigns.useGetCampaignListQuery,
    useSetIsCampaignFavouriteMutation = campaigns.useSetIsCampaignFavouriteMutation;
exports.useSetIsCampaignFavouriteMutation = useSetIsCampaignFavouriteMutation;
exports.useGetCampaignListQuery = useGetCampaignListQuery;
exports.useGetCampaignByIdQuery = useGetCampaignByIdQuery;
exports.useGetCampaignsQuery = useGetCampaignsQuery;